/**
 * Ask the person to confirm an action. On the web the browser's box answers at once; the
 * desktop's dialog answers later (Tauri has no blocking dialog), so every caller waits.
 *
 * Owner, 2026-10-14, from the error log: on desktop `window.confirm` returned a pending answer,
 * which reads as "yes", so destructive actions went ahead without asking.
 */
export async function confirmAction(message: string): Promise<boolean> {
  if (typeof window === "undefined" || typeof window.confirm !== "function") return true;
  return Boolean(await (window.confirm(message) as unknown as boolean | Promise<boolean>));
}
